import { Map } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

import VisaCheckoutCardInfoResponse from '../records/payment/VisaCheckoutCardInfoResponse';

export class VisaCheckoutStore extends BaseStore {
    getInitialState () {
        return new Map({
            amount: 0,
            addressUpdated: false,
            cardDetails: new VisaCheckoutCardInfoResponse(),
            loading: false,
            storedPaymentCallId: null,
            storePaymentCard: false
        });
    }

    handleAmount ({ amount }) {
        this.setState(this.state.merge({
            amount
        }));
    }

    handleStorePaymentCard ({ store }) {
        this.setState(this.state.merge({
            storePaymentCard: store
        }));
    }

    handleGetCardDetails () {
        this.setState(this.state.merge({
            loading: true
        }));
    }

    handleCardInfo ({ cardDetails }) {
        this.setState(this.state.merge({
            loading: false,
            cardDetails
        }));
    }

    handleStoredCardInfo ({ cardDetails }) {
        this.setState(this.state.merge({
            storedPaymentCallId: cardDetails.callId,
            cardDetails
        }));
    }

    handleDeliveryAddressUpdated({ addressUpdated }) {
        this.setState(this.state.merge({
            addressUpdated
        }));
    }

    getActionHandlers () {
        return {
            [ActionTypes.VISA_CO_SETUP]: this.handleAmount,
            [ActionTypes.VISA_CO_UPDATE_AMOUNT]: this.handleAmount,
            [ActionTypes.VISA_CO_STORE_PAYMENT_CARD]: this.handleStorePaymentCard,
            [ActionTypes.VISA_CO_GET_CARD_DETAILS]: this.handleGetCardDetails,
            [ActionTypes.VISA_CO_CARD_DETAILS_LOADED]: this.handleCardInfo,
            [ActionTypes.VISA_CO_STORED_PAYMENT_CARD_LOADED]: this.handleStoredCardInfo,
            [ActionTypes.VISA_CO_DELIVERY_ADDRESS_UPDATED]: this.handleDeliveryAddressUpdated,
            [ActionTypes.PAYMENT_LEFT]: this.resetState
        };
    }
}

const instance = new VisaCheckoutStore();

export default instance;



// WEBPACK FOOTER //
// ./src/stores/VisaCheckoutStore.js